import firebase from 'firebase';
import store from '@/store/store';
import axios from '@/axios/axios.js';

firebase.initializeApp({
  messagingSenderId: '948459033795'
});

const messaging = firebase.messaging();
if (Notification.permission !== 'granted') {
  messaging
    .requestPermission()
    .then(() => {
      return messaging.getToken();
    })
    .then(token => {
      localStorage.setItem('deviceID', token);
      axios
        .post('user/set-device-id', {
          device_id: token
        })
        .then(res => {
          // console.log('Uspesno konektovan');
        })
        .catch(err => {
          console.log(err);
        });
    })
    .catch(err => {
      console.log(err);
    });
}

messaging.onMessage(function (payload) {
  store.dispatch('updateNotifications');
  payload.notification.icon = 'https://i.imgur.com/XhAuIhA.png';
  new Notification(payload.notification.title, payload.notification);
});
